import { render, staticRenderFns } from "./ProductItemVariant.vue?vue&type=template&id=c6ec9cae&"
import script from "./ProductItemVariant.vue?vue&type=script&lang=js&"
export * from "./ProductItemVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports